module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/bg_lp-blue-398b78cbd35528b9cb0a1810240ac6a8.jpg";